import { useTable, usePagination, useSortBy } from "react-table";
import "./table.scss";
import Arrowup from "assets/imgs/icons/arrow_upblue.svg";
import Arrowdown from "assets/imgs/icons/arrow_downblue.svg";

export default function Table({
  columns,
  data,
  headerVisible = true,
  paginate = false,
  responsive = false,
  tableContainerClass,
  onRowClick,
  bordered = false,
  tableborderedcolor = false,
  Sorted = false,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useSortBy,
    usePagination
  );

  return (
    <div
      className={`${
        tableborderedcolor ? "cif_tablelist_tutor" : "cif__table-wrapper"
      }  `}
    >
      {paginate && (
        <div className="w-100 position-relative table__nav-btn-wrapper">
          <div className="table__nav-btn-group d-flex align-items-center text-right mt-2">
            <button
              disabled={!canPreviousPage}
              onClick={() => previousPage()}
              className="table__nav-btn"
            >
              <span class="material-icons">keyboard_arrow_left</span>
            </button>
            {/* {pageCount} / {pageIndex + 1} */}
            <button
              disabled={!canNextPage}
              onClick={() => nextPage()}
              className="table__nav-btn"
            >
              <span class="material-icons">keyboard_arrow_right</span>
            </button>
          </div>
        </div>
      )}
      <div
        className={`cif__table-table-container ${
          responsive ? "table-responsive" : ""
        } ${tableContainerClass}`}
      >
        <table
          {...getTableProps()}
          className={`${
            bordered
              ? " table  borderedtable  table-borderless "
              : "table table-borderless"
          }  `}
        >
          {headerVisible && (
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className={`${responsive ? "whitespace-nowrap" : ""}`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}

                      {Sorted && (
                        <span className="material-icons  ">
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <img
                                src={Arrowdown}
                                alt=""
                                className="img_height"
                              />
                            ) : (
                              <img
                                src={Arrowup}
                                alt=""
                                className="arrow_heightup"
                              />
                            )
                          ) : (
                            <span className="span_gap">-</span>
                          )}
                        </span>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          )}
          <tbody {...getTableBodyProps()}>
            {paginate
              ? page.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            onClick={() =>
                              onRowClick ? onRowClick(data[i]) : null
                            }
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              : rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            onClick={() =>
                              onRowClick ? onRowClick(data[i]) : null
                            }
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
